module.exports = __webpack_public_path__ + "img/svvkvikkleire.f06dd05a.jpg";